import React, { useEffect, useState } from 'react'
import { Grid, GridRow } from 'semantic-ui-react'
import Nav from '../../components/nav/nav'
const Homepage = (props) => {

  return (
      <>
      <Nav {...props} />
       <div className="x-homepage">
       <div className="x-banner">
         
       <Grid style={{height: "100%"}}>
         <Grid.Row className="x-flex">
          <Grid.Column mobile={16} computer={8} tablet={8} verticalAlign="middle" className="x-left">
           <h1>All The Food You Need In One App </h1>
          <div className="x-banner-desc">
          It’s simple: we list your favourite physical and virtual restaurants menu online, you order your preferred items, we pick them up and deliver in a heartbeat.
          </div>
          <div className="store">
          <a href="https://apps.apple.com/us/app/terrachow/id1587526296" className="x-download" target="__blank">
              <img src={process.env.PUBLIC_URL + './images/appstore.png'} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.terrachow.terrachow" className="x-download" target="__blank">
              <img src={process.env.PUBLIC_URL + './images/googleplay.png'} />
            </a>
          </div>
         {/* <Grid>
         <Grid.Row >
          <Grid.Column mobile={16} computer={8} tablet={8} verticalAlign="middle" textAlign="center">
            <a className="x-download" href="">
              <img src={process.env.PUBLIC_URL + './images/appstore.png'} />
            </a>
          </Grid.Column>
          <Grid.Column mobile={16} computer={8} tablet={8}  verticalAlign="middle" textAlign="center">
         
            </Grid.Column>
         </Grid.Row>
         </Grid> */}
          </Grid.Column>
          <Grid.Column className="x-right" mobile={16} computer={8} tablet={8}  verticalAlign="middle" textAlign="center">
              <img className="x-right-thumbnail" src="https://res.cloudinary.com/afrikal/image/upload/v1639218113/pepper_zctl1c.png" />
            </Grid.Column>
         </Grid.Row>
         </Grid>
       </div>
       </div>

      </>
  )
}


export default Homepage